// extracted by mini-css-extract-plugin
export default {"page":"forbidden_page__MHtWT","container":"forbidden_container__NcUmC","warning":"forbidden_warning__D1zAp","button":"forbidden_button__D8Ljj"};